import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./Alert.module.css";

const Alert: React.FC<AlertProps> = ({
  type,
  children,
  actions,
  className,
}) => (
  <div
    role="alert"
    className={classNames(styles.alert, className, {
      [styles.error]: type === "error",
      [styles.success]: type === "success",
    })}
  >
    <span>{children}</span>
    {actions && <div className={styles.actions}>{actions}</div>}
  </div>
);

export type AlertProps = {
  children?: ReactNode;
  type: "success" | "error" | "info";
  actions?: ReactNode;
  className?: string;
};

export default Alert;
